import React, { memo } from 'react';
import i18n from '@i18n';

import HeaderTitleSetter from '@/common/components/HeaderTitleSetter';
import { HybridTourContent } from '@/nikeone/components/TournamentContent';
import PropTypes from 'prop-types';
import NikeLogoIcon from '@/icons/NikeLogoIcon';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import BlockLoader from '@/ui/BlockLoader';
import FavoriteButton from '../components/favorites/FavoriteButton';
import { SINGLE_TOURNAMENT } from '../context/BoxOptionsContext';
import BoxOptionsContext from '../context/BoxOptionsContext';
import { useReframe, dispatch } from 'nike-re-framejs';
import useBoxStore from '../hook/useBoxStore';

const NikeOneTournament = memo(function NikeOneTournament({ boxId }) {
    const boxStore = `box:${boxId}`;
    useBoxStore(boxStore, SINGLE_TOURNAMENT, [boxId]);
    const derefSub = useReframe();

    const boxLoaded = derefSub(['nikeone/loading/box/done', boxId]);
    const hasNoSection = derefSub(['nikeone/box/hasNoSection', boxStore, boxId]);
    const title = derefSub(['nikeone/box/title', boxStore, boxId]);
    const isFavorite = derefSub(['favourite.ids.menuItems.isFavorite', boxId]);
    const handleFavoriteClick = () => dispatch(['favourite.item.toggle', boxId]);

    if (!boxLoaded) {
        return <BlockLoader />;
    }

    if (boxLoaded && hasNoSection) {
        return <TournamentNotFound />;
    }
    return (
        <>
            <HeaderTitleSetter title={`${title}`} />
            <FavoriteButton className="in-header" active={isFavorite} onClick={handleFavoriteClick} />
            <div className="page-tournament">
                <BoxOptionsContext.Provider value={SINGLE_TOURNAMENT}>
                    <HybridTourContent boxStore={boxStore} boxId={boxId} />
                </BoxOptionsContext.Provider>
            </div>
        </>
    );
});

NikeOneTournament.propTypes = {
    boxId: PropTypes.string
};
const TournamentNotFound = function() {
    const stateIcon = <NikeLogoIcon width={76} height={32} opacity={1} fill={'#aab2bd'} />;
    return <EmptyState stateIcon={stateIcon} text={i18n('error.sportTournament.detail.nodata')} />;
};

export function NikeOneMenuItemTournament({ sportSlugPart, countrySlugPart, tournamentSlugPart }) {
    const derefSub = useReframe();
    const loading = derefSub(['nikeone.menuNotLoadedYet']);
    const sportSlug = `/${sportSlugPart}`;
    const slug = `/${sportSlugPart}/${countrySlugPart}/${tournamentSlugPart}`;
    if (loading) {
        return <BlockLoader />;
    }

    const boxId = derefSub(['sub::nikeone.boxIdFromMenu', sportSlug, slug]);
    if (!boxId) {
        return <TournamentNotFound />;
    }

    return <NikeOneTournament boxId={boxId} />;
}

NikeOneMenuItemTournament.propTypes = {
    sportSlugPart: PropTypes.string,
    countrySlugPart: PropTypes.string,
    tournamentSlugPart: PropTypes.string
};

export default NikeOneTournament;
